import { requireOptionalNativeModule } from 'expo';
export default requireOptionalNativeModule('ExpoStatusBar');

//# sourceMappingURL=ExpoStatusBar.js.map
